<template>
  <div class="form-group relative">
    <div class="overlay-disable-edit" v-if="isDisableEditPresentation"></div>

    <div class="setting-block qna-block">
      <label class="label-option">
        When can the audience send you questions?
      </label>
      <div class="block-body" style="margin-left: 16px;">
        <div class="item-qna">
          <input
            type="radio"
            id="customCheckboxqna-slide"
            name="customCheckboxqna-slide"
            value="true"
            v-model="presentation.qnaAllSlide"
            @change="changeSettingPresentation(1)"
          />
          <label for="customCheckboxqna-slide">On all slides</label>
        </div>
        <div class="item-qna">
          <input
            type="radio"
            id="customCheckboxqna1-slide"
            name="customCheckboxqna1-slide"
            value="false"
            v-model="presentation.qnaAllSlide"
            @change="changeSettingPresentation(1)"
          />
          <label for="customCheckboxqna1-slide">Only on Q&A slides</label>
        </div>
      </div>

      <!-- 17. Filter profanity -->
      <div class="block-content">
        <div class="form-check form-check-inline" v-if="profanityFilterVisible">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="check-profanity-filter"
              :disabled="isDisableWhenNotOwner"
              v-model="presentation.filteringProfanity"
              @change="changeSettingPresentation(4)"
            />
            <label
              class="custom-control-label"
              for="check-profanity-filter"
            >Filter profanity</label>
            <span class="pl-1 title-table-presentation-tooltip">
              <b-button
                v-tooltip="'Hide inappropriate words submitted by the audience on all slides'"
                class="tooltip-btn"
              />
              <i class="fas fa-question-circle" />
            </span>
          </div>
        </div>
      </div>

      <!-- QnA Moderation -->
      <QnAModerationCheckBox />

      <div class="block-content">
        <div class="form-check form-check-inline">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="check-hide-qnaAudienceShowAll-slide"
              v-model="presentation.qnaAudienceShowAll"
              @change="changeSettingPresentation(2)"
            />
            <label class="custom-control-label" for="check-hide-qnaAudienceShowAll-slide">
              Allow audience to see each other's questions
            </label>
            <span class="pl-1 title-table-presentation-tooltip">
              <b-button
                v-tooltip="allowAudienceSeeEachOtherTooltip"
                class="tooltip-btn"
              />
              <i class="fas fa-question-circle" />
            </span>
          </div>
        </div>
      </div>

      <div class="block-content">
        <div class="form-check form-check-inline">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="check-hide-qnaAnonymous-slide"
              v-model="presentation.qnaAnonymous"
              @change="changeSettingPresentation(3)"
            />
            <label
              class="custom-control-label"
              for="check-hide-qnaAnonymous-slide"
            >Allow anonymous questions</label>
            <span class="pl-1 title-table-presentation-tooltip">
              <b-button
                v-tooltip="'Allow your audience to submit questions without providing their names'"
                class="tooltip-btn"
              />
              <i class="fas fa-question-circle" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import QnAModerationCheckBox from '@/components/presentations/QnAModerationCheckBox.vue'
import QnAModerationCheckBoxContainer from '@/containers/qna-moderation/QnAModerationCheckBox'
import Socket from '@/socket'
import utils from '@/util'
import PresentationApi from '@/api/presentation'

export default {
  components: {
    QnAModerationCheckBox: QnAModerationCheckBoxContainer(QnAModerationCheckBox),
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
    }),
    ...mapGetters(['isDisableWhenNotOwner']),
    profanityFilterVisible() {
      const slideTypes = ['openEnded', 'wordCloud', 'question', 'pickAnswer', 'leaderboard', 'ideas']
      return slideTypes.includes(this.slideActive.type)
    },
    allowAudienceSeeEachOtherTooltip() {
      return 'Allow the audience to see all questions on their smartphones and vote for what they want to be answered most'
    },
  },
  methods: {
    changeSettingPresentation(type) {
      const payload = {
        socketId: Socket.getSocketId(),
      }
      let text = ''
      if (type == 1) {
        payload.qnaAllSlide = this.presentation.qnaAllSlide
        text = 'Q&A on all slides'
        if (payload.qnaAllSlide == 'false') {
          text = 'Q&A only on Q&A slides'
        }
        utils.gaTrackEvent('Question And Answer', 'Q&A settings', text)
      } else if (type == 2) {
        payload.qnaAudienceShowAll = this.presentation.qnaAudienceShowAll
        text = "Checked allow audience to see each other's questions"
        if (!payload.qnaAudienceShowAll) {
          text = "Unchecked allow audience to see each other's questions"
        }
        utils.gaTrackEvent('Question And Answer', 'Q&A settings', text)
      } else if (type == 3) {
        payload.qnaAnonymous = this.presentation.qnaAnonymous
        text = 'Checked allow anonymous questions'
        if (!payload.qnaAnonymous) {
          text = 'Uncheck allow anonymous questions'
        }
        utils.gaTrackEvent('Question And Answer', 'Q&A settings', text)
      } else if (type == 4) {
        payload.filteringProfanity = this.presentation.filteringProfanity
      }
      this._updatePresentation(payload)
    },

    async _updatePresentation(payload) {
      try {
        await PresentationApi.updatePresentationByPresentationId(this.presentation.id, payload)
      } catch (error) {
        //
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.qna-block {
  .block-content {
    margin-bottom: 16px;
    .form-check-inline {
      cursor: pointer;

      input,
      label {
        cursor: pointer;
      }
    }
  }

  .block-body {
    margin-bottom: 8px !important;
  }
}
.item-qna {
  cursor: pointer;

  label {
    cursor: pointer;
  }

  input {
    margin-right: 4px;
    position: relative;
    top: -1px;
    cursor: pointer;
  }
}

.overlay-disable-edit {
  @apply bg-base-0 opacity-50 absolute left-0 w-full h-full;
  top: 0;
  z-index: 9;
}
</style>
